const COLLAPSED_HEIGHT = 128;

export function initProductDescriptions(root = document) {
  root.querySelectorAll('[data-product-description]').forEach((section) => {
    if (section.dataset.descriptionReady === 'true') return;
    const content = section.querySelector('[data-product-description-content]');
    const button = section.querySelector('[data-product-description-toggle]');
    const label = section.querySelector('[data-product-description-label]');
    if (!content || !button || !label) return;

    section.dataset.descriptionReady = 'true';
    let expanded = false;
    let overflowing = false;
    let measurementQueued = false;
    const render = () => {
      section.classList.toggle('is-overflowing', overflowing);
      section.classList.toggle('is-expanded', overflowing && expanded);
      button.hidden = !overflowing;
      button.setAttribute('aria-expanded', String(overflowing && expanded));
      label.textContent = expanded && overflowing ? label.dataset.less : label.dataset.more;
    };
    const measure = () => {
      overflowing = content.scrollHeight > COLLAPSED_HEIGHT;
      if (!overflowing) expanded = false;
      render();
    };
    const scheduleMeasure = () => {
      if (measurementQueued) return;
      measurementQueued = true;
      window.requestAnimationFrame(() => {
        measurementQueued = false;
        measure();
      });
    };

    button.addEventListener('click', () => {
      expanded = !expanded;
      render();
    });
    content.addEventListener('focusin', () => {
      if (!overflowing || expanded) return;
      expanded = true;
      render();
    });
    window.addEventListener('resize', scheduleMeasure);
    window.addEventListener('load', scheduleMeasure);
    if (typeof document !== 'undefined') document.fonts?.ready.then(scheduleMeasure);
    if (typeof ResizeObserver !== 'undefined') {
      const observer = new ResizeObserver(scheduleMeasure);
      observer.observe(content.firstElementChild || content);
    }
    measure();
  });
}

if (typeof document !== 'undefined') initProductDescriptions();
